import { Component, OnInit, ViewChild } from '@angular/core';
import { AutoCheckAccountRequestDto, ConfigurationState, LaunchDarklyService, VehicleHistoryReportService } from 'remarketing-angular-library';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RemoveUserIdModalComponent } from '../remove-user-id-modal/remove-user-id-modal.component';
import { take, takeUntil } from 'rxjs/operators';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { SaComponent } from 'smartauction-frontend-micro-library';
import { CommonInterstitialModalComponent, CommonInterstitialModalTranslations } from 'remarketing-ui-components-lib';
import { get } from 'lodash';
import { Store } from '@ngxs/store';
import { SuccessMessageComponent } from '../success-message/success-message.component';
import { NgTemplateOutlet, NgClass } from '@angular/common';

@Component({
    selector: 'app-auto-check',
    templateUrl: './auto-check.component.html',
    styleUrls: ['./auto-check.component.scss'],
    imports: [TranslocoDirective, SuccessMessageComponent, NgTemplateOutlet, NgClass, FormsModule, ReactiveFormsModule, RemoveUserIdModalComponent, CommonInterstitialModalComponent]
})
export class AutoCheckComponent extends SaComponent implements OnInit {
  userIdFormGroup: UntypedFormGroup;
  openDrawer = false;
  isUserIdAvailable = false;
  addingAutoCheckUserId = false;
  autoCheckUserId: string;
  showSuccess = false;
  userIdChanged = false;
  readonly autoCheckConstant: string = 'AutoCheck';
  @ViewChild(RemoveUserIdModalComponent) removeUserIdModalComponent: RemoveUserIdModalComponent;
  @ViewChild(CommonInterstitialModalComponent) commonInterstitialModalComponent: CommonInterstitialModalComponent;

  commonInterstitialModalTranslations: CommonInterstitialModalTranslations = {
    cancelBtn: '',
    continueBtn: '',
    subtext1: '',
    subtext2: '',
    text: '',
    title: ''
  };

  get tenantFullName(): string {
    return get(this.store.selectSnapshot(ConfigurationState.configuration), 'tenantFullName', '').replace('Canada','');
  }

  get autoCheckUrl(): string {
    return this.launchDarklyService.getFeatureFlag('autocheck-url', '');
  }

  constructor(
    private readonly vehicleHistoryReportService: VehicleHistoryReportService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly translocoService: TranslocoService,
    private readonly store: Store,
    private readonly launchDarklyService: LaunchDarklyService
  ) {
    super();
  }

  ngOnInit(): void {
    this.getAutoCheckUserId();
    this.getTranslations();
  }

  getAutoCheckUserId() {
    this.vehicleHistoryReportService.getAutoCheckAccountUserId().pipe(take(1)).subscribe(
      response => {
        if (response.accountNumber) {
          this.autoCheckUserId = response.accountNumber;
          this.isUserIdAvailable = true;
          this.isUserIdAvailable = true;
          this.addingAutoCheckUserId = true;
          this.userIdFormGroup = this.formBuilder.group({
            userId: this.autoCheckUserId
          });
        }
      },
      () => {
        this.isUserIdAvailable = false;
      });
  }

  addUserId() {
    this.openDrawer = true;
    this.addingAutoCheckUserId = true;
    this.userIdFormGroup = this.formBuilder.group({
      userId: null
    });
  }

  get isDrawerOpen(): boolean {
    return this.openDrawer;
  }

  closeDrawer() {
    this.openDrawer = false;
  }

  saveUserId() {
    this.openDrawer = this.userIdFormGroup.controls.userId.value === null || this.userIdFormGroup.controls.userId.value.length === 0;
    this.validateFormAndSave();
  }

  onEditAutoCheckUserId() {
    this.openDrawer = true;
    this.showSuccess = false;
  }

  onRemoveUserId(userIdRemoved) {
    this.removeUserIdModalComponent.show();
    if (userIdRemoved) {
      this.openDrawer = false;
      this.showSuccess = false;
      this.isUserIdAvailable = false;
      this.vehicleHistoryReportService.deleteAutoCheckAccountUserId().pipe(take(1)).subscribe(() => {
        // This is intentional
      }, () => {
        this.isUserIdAvailable = true;
      });
    }
  }

  validateFormAndSave() {
    if (this.userIdFormGroup.controls.userId.value) {
      this.isUserIdAvailable = true;
      this.autoCheckUserId = this.userIdFormGroup.controls.userId.value;
      const payload = {
        accountNumber: this.autoCheckUserId
      } as AutoCheckAccountRequestDto;

      this.vehicleHistoryReportService.saveAutoCheckAccountUserId(payload).pipe(take(1)).subscribe(() => {
        this.showSuccess = true;
      },
      () => {
        this.isUserIdAvailable = false;
        this.showSuccess = false;
      });
    }
  }

  removeSuccessMessage() {
    this.showSuccess = false;
  }

  openAutoCheckUrlNewTab() {
    this.commonInterstitialModalComponent.show();
  }

  continueToAutoCheckUrlNewTab(confirmed) {
    if (confirmed) {
      window.open(this.autoCheckUrl);
    }
  }

  getTranslations() {
    const keyParams = {
      'UIComponents.commonInterstitialModal': {},
    };

    this.translocoService.selectTranslateObject(keyParams).pipe(takeUntil(this.destroyed$)).subscribe(translate => {
      this.commonInterstitialModalTranslations = translate[0];
    });
  }

}
